import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';
import { ApplicationSettings } from '@cupoui/shared/model/application.settings';

export const SETTINGS_CONFIG = new InjectionToken<ApplicationSettings>('SETTINGS_CONFIG');

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  public static readonly CONFIG_URL = 'assets/env/application-config.json';
  private readonly configuration: ApplicationSettings;

  constructor(@Optional() @Inject(SETTINGS_CONFIG) config?: ApplicationSettings) {
    this.configuration = config ?? new ApplicationSettings();
  }

  getApp(): string {
    return this.configuration.app;
  }

  getCupouiEndpoint(): string {
    return this.configuration.cupouiEndpoint;
  }

  isProduction(): boolean {
    return this.configuration.isProduction;
  }

  isTest(): boolean {
    return this.configuration.isTest;
  }

  isLocal(): boolean {
    return !this.isProduction() && !this.isTest();
  }

  getGoogleAPIKey() : string {
    return this.configuration.googleAPIKey;
  }

  getTableauEndpoint(): string {
    return this.configuration.tableauEndpoint;
  }

  getKeycloakSettings() {
    return this.configuration.keycloak;
  }
}
